import BaseModel from './BaseModel'
import { oneToOne } from 'redux-orm'
import axiosInstance from 'api/axios.config'
import {
  NEW_FAVORITE_CREATED,
  FAVORITE_REMOVED,
  FINISH_FETCHING_FAVORITES,
  CLEAR_FAVORITES
} from '../redux/actions/favorite'

class Favorite extends BaseModel {
  static reducer (action, Favorite, session) {
    switch (action.type) {
      case NEW_FAVORITE_CREATED:
        Favorite.create({
          ...action.favorite,
          planEntry: action.favorite.planEntryId
        })
        break
      case FAVORITE_REMOVED:
        const favoriteToDelete = Favorite.withId(action.favoriteId)
        if (favoriteToDelete) {
          favoriteToDelete.delete()
        }
        break
      case CLEAR_FAVORITES:
        Favorite.all().delete()
        break
      case FINISH_FETCHING_FAVORITES:
        action.favorites.forEach(favorite => {
          Favorite.create({
            ...favorite,
            planEntry: favorite.planEntry.id
          })

          if (!session.PlanEntry.withId(favorite.planEntry.id)) {
            session.PlanEntry.create({
              ...favorite.planEntry,
              planProduct: favorite.planEntry.plan.id
            })

            const plan = favorite.planEntry.plan
            if (!session.Product.withId(plan.id)) {
              session.Product.create(plan)
            }
          }
        })
        break
    }
  }

  removeFavorite () {
    return axiosInstance.delete(`/favorites/${this.id}`)
  }

  static createNewFavorite (planEntryId, params) {
    return axiosInstance.post('/favorites', {
      ...params,
      plan_entry_id: planEntryId
    })
  }
}

Favorite.fields = {
  planEntry: oneToOne('PlanEntry', 'favorite')
}

Favorite.apiPath = '/favorites'

Favorite.modelName = 'Favorite'

export default Favorite
